import {
  Box,
  CardHeader,
  Grid,
  IconButton,
  LinearProgress,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  AddOutlined,
  DeleteOutline,
  EditOutlined,
  RefreshOutlined,
} from "@material-ui/icons";
import useConfirmation from "../../../hooks/useConfirmation";
import useToast from "../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../shares/NotificationBull";
import AssociationExperienceForm from "./AssociationExperienceForm";
import AppButton from "../shares/AppButton";
import { AssociationExperienceService } from "../../../service/AssociationExperienceService";
import { DataGrid } from "@mui/x-data-grid";
import { frFR } from "@mui/x-data-grid/locales";
import { use } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "../../../hooks/useQuery";
import { showNumbreFormat } from "../../../Helpers/utilsHelper";

export function calculeExperience(date_debut, date_fin) {
  let dateFin = date_fin ? new Date(date_fin) : new Date();
  let dateDebut = new Date(date_debut);
  try {
    const differenceInDays = dateFin.getDate() - dateDebut.getDate();
    const differenceInMonths =
      (dateFin.getFullYear() - dateDebut.getFullYear()) * 12 +
      (dateFin.getMonth() - dateDebut.getMonth());
    const differenceInYears = Math.floor(differenceInMonths / 12);
    const remainingMonths = differenceInMonths % 12;
    return {
      annee: differenceInYears,
      mois: remainingMonths + Number((differenceInDays / 30).toFixed(1)),
    };
  } catch (e) {
    console.error(
      "Erreur lors de la conversion des dates en experience. Erreur: ",
      e
    );
    return { annee: 0, mois: 0 };
  }
}

export function calculeTotalExperience(annee, mois) {
  const totalMois = annee * 12 + mois;
  const totalAnnee = Math.floor(totalMois / 12);
  const totalMoisRestant = totalMois % 12;
  return { annee: totalAnnee, mois: totalMoisRestant };
}

const ExperienceProfessionnelsAssociation = ({ currentAssociation }) => {
  const [currentExperience, setCurrentExperience] = useState({});
  const [educationFormDialogOpen, setEducationFormDialogOpen] = useState(false);
  const [experiences, setExperiences] = useState([]);
  const { DialogComponent, openConfirmDialog } = useConfirmation();
  const [dataLoading, setDataLoading] = useState(false);
  const { Toast, showToast } = useToast();
  const navigate = useNavigate();
  const url = useQuery();

  const confirmDelete = (experience) => {
    AssociationExperienceService.delete(experience).then((res) => {
      if (res && res.success) {
        showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
        handleFetchExperience();
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, res.message);
      }
    });
  };

  const handleDeleteExperience = (experience) => {
    openConfirmDialog(
      "Confirmation",
      "Voulez vous supprimer cette ligne?",
      () => confirmDelete(experience)
    );
  };

  const handleCloseExperienceForm = () => {
    setEducationFormDialogOpen(false);
    setCurrentExperience({});
    handleFetchExperience();
  };

  const handleFetchExperience = () => {
    setDataLoading(true);
    AssociationExperienceService.getAll({
      id_association: currentAssociation.id_ext_association,
    })
      .then((res) => {
        if (res && res.data) {
          setExperiences(res.data);
        }
      })
      .finally(() => {
        setDataLoading(false);
      });
  };

  const handleConfirmSelectOffreForExperience = () => {
    openConfirmDialog(
      "Selectionner une offre",
      "Vous devez postuler à une offre pour ajouter une experience. Voulez-vous choisir l'offre à postuler ?",
      () => {
        navigate("/offre-emploi");
      },
      () => {}
    );
  };

  const handleCreateExperience = () => {
    if (url.get("job_id") === null) {
      handleConfirmSelectOffreForExperience();
    } else {
      setEducationFormDialogOpen(true);
      setCurrentExperience({});
    }
  };

  const handleUpdateExperience = (experience) => {
    setEducationFormDialogOpen(true);
    setCurrentExperience(experience);
  };

  const colonne = [
    {
      field: "date_debut",
      headerName: "Date de debut",
      width: 180,
      renderCell: (params) => {
        return (
          <span>{new Date(params.row.date_debut).toLocaleDateString()}</span>
        );
      },
    },
    {
      field: "date_fin",
      headerName: "Date de fin",
      width: 180,
      renderCell: (params) => {
        let date_f = new Date(params.row.date_fin);
        return (
          <span>
            {params.row.date_fin === "0000-00-00 00:00:00"
              ? "--"
              : date_f.toLocaleDateString("fr-FR") || "--"}
          </span>
        );
      },
    },
    {
      field: "titre_mission",
      headerName: "Titre du prestation",
      width: 180,
      renderCell: (params) => {
        return <span>{params.row.titre_mission}</span>;
      },
    },
    {
      field: "entreprise",
      headerName: "Entreprise/Organisme",
      width: 180,
      renderCell: (params) => {
        return <span>{params.row.entreprise}</span>;
      },
    },
    {
      field: "mission",
      headerName: "Description du mission",
      width: 300,
      renderCell: (params) => {
        return (
          <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
            {params.value}
          </div>
        );
      },
    },
    {
      field: "montant_marche",
      headerName: "Montant du marché",
      width: 300,
      renderCell: (params) => {
        return (
          <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
            { params.value ? `MGA ${showNumbreFormat(params.value)}` : '--' }
          </div>
        );
      },
    },
    {
      field: "reference1",
      headerName: "Personne réference",
      width: 180,
      renderCell: (params) => {
        return <span>{params.row.reference1}</span>;
      },
    },
    {
      field: "contact_ref1",
      headerName: "Contact du réference",
      width: 180,
      renderCell: (params) => {
        return <span>{params.row.contact_ref1}</span>;
      },
    },
    {
      field: "mail_ref1",
      headerName: "Email du réference",
      width: 180,
      renderCell: (params) => {
        return <span>{params.row.mail_ref1}</span>;
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 180,
      renderCell: (params) => {
        return (
          <Grid>
            <IconButton
              title="Modifier"
              color="primary"
              onClick={(e) => handleUpdateExperience(params.row)}
            >
              <EditOutlined />
            </IconButton>
            <IconButton
              title="Supprimer"
              color="warning"
              onClick={(e) => handleDeleteExperience(params.row)}
            >
              <DeleteOutline />
            </IconButton>
          </Grid>
        );
      },
    },
  ];

  useEffect(() => {
    handleFetchExperience();
  }, []);

  return (
    <>
      <AssociationExperienceForm
        open={educationFormDialogOpen}
        onFormClose={handleCloseExperienceForm}
        idExperience={currentExperience.id_ext_asso_exp}
        currentAssociation={currentAssociation}
      />
      <DialogComponent />
      <Toast />
      <CardHeader
        title={
          <Grid display={{ xs: "none", sm: "block" }}>
            Expériences de l'Association/Agence
          </Grid>
        }
        titleTypographyProps={{ variant: "h5" }}
        action={
          <Grid>
            <AppButton
              icon={<AddOutlined />}
              text={"Ajouter"}
              variant={"contained"}
              onClick={handleCreateExperience}
            />
          </Grid>
        }
        avatar={
          <Grid>
            <IconButton color="primary" onClick={handleFetchExperience}>
              <RefreshOutlined />
            </IconButton>
          </Grid>
        }
      />
      <Grid>
        <Box display={dataLoading ? "" : "none"} sx={{ width: "100%" }}>
          <LinearProgress />
        </Box>
        <DataGrid
          columns={colonne}
          rows={experiences}
          pageSize={5}
          getRowHeight={() => "auto"}
          rowHeight={25}
          sx={{
            width: {
              xs: "85.5vw",
              sm: "90vw",
              md: "93.5vw",
              lg: "100%",
            },
            "& .MuiDataGrid-cell": {
              borderRight: "1px solid rgba(224, 224, 224, 1)",
              alignContent: "center",
            },
            "& .MuiDataGrid-columnHeaders": {
              borderRight: "1px solid rgba(224, 224, 224, 1)",
            },
          }}
          autoHeight
          getRowId={(row) => row.id_ext_asso_exp}
          localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
        />
      </Grid>
    </>
  );
};

export default ExperienceProfessionnelsAssociation;
